export default __webpack_public_path__ + "static/media/P2-Tip-Solution.bcdf7c9f.svg";